module.exports = "<div ui-view class=\"appstore\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/apps/apps.html
// module id = 189
// module chunks = 0